<template>
    <v-container fill-height fluid class="pa-1" v-if="$vuetify.breakpoint.xsOnly">
      <v-layout fill-height column justify-center text-xs-center>
        <v-flex xs12>
          <v-layout fill-height column justify-center>
            <a href="https://accessibleretail.co.uk/" target="_blank" title="Visit Website">
              <v-img contain="" height="150" :src="require('@/assets/ar-logo.svg')"></v-img>
            </a>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-card-title primary-title>
            <v-container fluid>
              <v-layout align-center justify-center column>
                <v-flex sm12 class="text-xs-center">
                  <p :class="fontClass">Accessible Retail (AR), is the trade body which represents the property
                    interests of the retail warehouse and retail park sector of the retail industry.</p>
                </v-flex>
                <v-flex xs12>
                  <v-btn href="https://accessibleretail.co.uk/" color="primary">
                    Visit Website
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-flex>
        <v-flex xs12>
          <v-layout fill-height column justify-center>
            Build: {{ version }}
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid class="pa-3" v-else>
      <v-layout column justify-center text-xs-center>
        <v-flex xs12>
          <a href="https://accessibleretail.co.uk/" target="_blank" title="Visit Website">
            <v-img contain="" height="150" :src="require('@/assets/ar-logo.svg')"></v-img>
          </a>
        </v-flex>
        <v-flex xs12>
          <v-card-title primary-title>
            <v-container fluid>
              <v-layout align-center justify-center column>
                <v-flex sm12 class="text-xs-center">
                  <p :class="fontClass">Accessible Retail (AR), is the trade body which represents the property
                    interests of the retail warehouse and retail park sector of the retail industry.</p>
                </v-flex>
                <v-flex xs12>
                  <v-btn href="https://accessibleretail.co.uk/" color="primary">
                    Visit Website
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
        </v-flex>
        <v-flex xs12>
          Build: {{ version }}
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'About',
  created () {
    this.setTitle({ title: 'About' })
  },
  computed: {
    fontClass () {
      return (this.$vuetify.breakpoint.xsOnly) ? 'caption' : 'headline'
    },
    ...mapGetters(
      'application', {
        version: 'version'
      }
    )
  },
  methods: {
    ...mapActions('application', { setTitle: 'setTitle' }
    )
  }
}
</script>
